import { required, numeric, maxLength, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    option: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a option name.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Option name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        pattern: helpers.withMessage(i18n.global.t('Name can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Za-zก-๙0-9_/&+.,'"()% -]+$/)),
      },
      // ชื่ออังกฤษ optional — ไม่กรอกก็ได้ ระบบจะ fallback ไปใช้ชื่อไทย
      name_en: {
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Option name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        pattern: helpers.withMessage(i18n.global.t('English name can include English letters, numbers, and certain special characters.'), helpers.regex(/^[A-Za-z0-9_/&+.,'"()% -]+$/)),
      },
      price_adjustment: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      is_default: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      }
      // recipes เป็น optional — option ไม่มีสูตร = ไม่ตัดสต็อก/ต้นทุน 0
      // มี $swal ยืนยันรวมตอนกด Save ที่ OffcanvasForm (confirmNoRecipeOptions)
    }
  }
};
